import React, { FC } from 'react'
import GenericModal from '../../../widgets/GenericModal'
import { APP_NAME } from '../../../constants'

interface Props {
  isOpen: boolean
  onCancel: () => void
  onSubmit: () => void
}

const ProjectLimitModal: FC<Props> = (props) => {
  const { isOpen, onCancel, onSubmit } = props

  return (
    <GenericModal
      isOpen={isOpen}
      onCancel={onCancel}
      onSubmit={onSubmit}
      headingText={`Get more organized with ${APP_NAME} Pro`}
      bodyText={`${APP_NAME} Basic provides up to 10 Folders. Upgrade to Pro for up to 100 Folders.`}
      cancelButtonText="Dismiss"
      submitButtonText="Upgrade"
    />
  )
}

export default ProjectLimitModal
